import { A48ReportPerms } from "../enums/reports/a48-report-perms.enum";
import { A48ReportTypes } from "../enums/reports/a48-reports.enum";
import { TimeTrackingTypes } from "./enum/cpl-time-tracking-type.enum";

export class CplTimeTrackingReportRequest {
    UserID: string;
    StartDate: Date;
    EndDate: Date;
    Type: A48ReportTypes;
    Perms: A48ReportPerms;
    TimeTrackingType: TimeTrackingTypes;
    ShowDetails: boolean;
    ShowUserPicker: boolean;
    ShouldGetAll: boolean;
    Offset?: number;
    Limit?: number;
}